module.exports = __webpack_public_path__ + "img/g12.df1e062b.jpg";